import React from 'react';
import { Eye, MessageSquare } from 'lucide-react';
import { trackWhatsAppClick, trackModelView } from '../services/adminStorage';

export default function ModelCard({ model, onSelectModel }) {
  const handleQuote = (e) => {
    e.stopPropagation();
    trackWhatsAppClick(model.id);
    const message = encodeURIComponent(`Olá, Suzume Technologies! Gostaria de solicitar um orçamento para a landing page do modelo: "${model.name}" (Categoria: ${model.category}).`);
    window.open(`https://wa.me/5511932654166?text=${message}`, '_blank');
  };

  const handleSelect = () => {
    trackModelView(model.id);
    onSelectModel(model);
  };

  return (
    <div className="model-card">
      <div 
        className="model-card-thumb" 
        style={{ background: model.gradient || 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' }}
      >
        <span className="model-card-badge">{model.category}</span>
        
        {/* Mockup visual de exemplo dentro do card */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '12px',
          padding: '1.25rem 1.5rem',
          textAlign: 'center',
          width: '85%',
          boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
        }}>
          <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em', opacity: 0.9 }}>Preview Mockup</div>
          <div style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '0.25rem' }}>{model.name}</div>
        </div>
      </div>

      <div className="model-card-content">
        <div style={{ marginBottom: '0.5rem' }}>
          <h3 className="model-card-title">{model.name}</h3>
        </div>

        <p className="model-card-desc">{model.description}</p>

        <div className="model-tags">
          {model.tags && model.tags.map((tag, idx) => (
            <span key={idx} className="model-tag">#{tag}</span>
          ))}
        </div>

        <div className="model-card-footer">
          <button 
            className="btn btn-secondary btn-sm" 
            onClick={handleSelect}
            title="Ver modelo detalhado"
          >
            <Eye size={16} />
            <span>Ver modelo</span>
          </button>
          <button 
            className="btn btn-whatsapp btn-sm" 
            onClick={handleQuote}
            title="Solicitar orçamento via WhatsApp"
          >
            <MessageSquare size={16} />
            <span>Solicitar orçamento</span>
          </button>
        </div>
      </div>
    </div>
  );
}
